/** Tiny typed DOM helpers — no framework. */

type Child = Node | string | number | null | undefined | false;
type Attrs = Record<string, string | number | boolean | EventListener | null | undefined>;

export function h<K extends keyof HTMLElementTagNameMap>(tag: K, attrs: Attrs = {}, ...children: Child[]): HTMLElementTagNameMap[K] {
  const el = document.createElement(tag);
  for (const [k, v] of Object.entries(attrs)) {
    if (v === null || v === undefined || v === false) continue;
    if (k.startsWith('on') && typeof v === 'function') el.addEventListener(k.slice(2).toLowerCase(), v as EventListener);
    else if (k === 'class') el.className = String(v);
    else if (k === 'text') el.textContent = String(v);
    else if (k === 'html') el.innerHTML = String(v);
    else if (v === true) el.setAttribute(k, '');
    else el.setAttribute(k, String(v));
  }
  for (const c of children) {
    if (c === null || c === undefined || c === false) continue;
    el.append(c instanceof Node ? c : document.createTextNode(String(c)));
  }
  return el;
}

export function clear(el: Element): void {
  while (el.firstChild) el.removeChild(el.firstChild);
}

export function byId<T extends HTMLElement = HTMLElement>(id: string): T {
  const el = document.getElementById(id);
  if (!el) throw new Error(`#${id} missing`);
  return el as T;
}

/**
 * Bindings: build DOM once, then refresh only the dynamic bits on a timer
 * (v0.9 rebuilt innerHTML every second and swallowed clicks mid-render).
 */
export class Bindings {
  private fns: (() => void)[] = [];
  add(fn: () => void): void {
    this.fns.push(fn);
    fn();
  }
  run(): void {
    for (const fn of this.fns) fn();
  }
  reset(): void {
    this.fns = [];
  }
}

export function progressBar(frac: number): HTMLElement {
  const bar = h('div', { class: 'progress' }, h('span'));
  setProgress(bar, frac);
  return bar;
}

export function setProgress(bar: HTMLElement, frac: number): void {
  (bar.firstElementChild as HTMLElement).style.width = `${Math.max(0, Math.min(1, frac)) * 100}%`;
}
